import { useState, useCallback } from 'react';

import { HotelFareFinalDto, PaxResponseDto } from '@bandido/shared/dtos';

import { HotelPaxSelector } from '../hotel-pax-selector';
import { HotelHolderData } from '../holder-data';
import { Form as HolderDataForm } from '../holder-data/form';

enum WizardStep {
  PAX_DATA = 'pax-data',
  HOLDER_SELECTION = 'holder-selection'
}

type Props = Pick<HotelFareFinalDto, 'occupancies'> & {
  saleOrderItemId: string;
  saleOrderId: string;
  open: boolean;
  onClose: () => void;
  onComplete: (data: HolderDataForm) => void;
  cartPaxes: PaxResponseDto[];
  isLoading?: boolean;
  checkinDate?: string;
};

export const HotelBookingWizard = ({
  saleOrderItemId,
  saleOrderId,
  open,
  onClose,
  onComplete,
  occupancies,
  cartPaxes,
  checkinDate
}: Props) => {
  const [currentStep, setCurrentStep] = useState<WizardStep>(WizardStep.PAX_DATA);

  const handlePaxDataContinue = useCallback(() => {
    setCurrentStep(WizardStep.HOLDER_SELECTION);
  }, []);

  const handleHolderDataContinue = useCallback((data: HolderDataForm) => {
    onComplete(data);
  }, [onComplete]);

  const handleBackToPaxData = useCallback(() => {
    setCurrentStep(WizardStep.PAX_DATA);
  }, []);

  const handleClose = useCallback(() => {
    setCurrentStep(WizardStep.PAX_DATA);
    onClose();
  }, [onClose]);

  if (!open) {
    return null;
  }

  return (
    <>
      {currentStep === WizardStep.PAX_DATA && (
        <HotelPaxSelector
          saleOrderId={saleOrderId}
          saleOrderItemId={saleOrderItemId} 
          occupancies={occupancies}
          cartPaxes={cartPaxes}
          checkinDate={checkinDate}
          onBack={handleClose}
          onContinue={handlePaxDataContinue}
        />
      )}

      {currentStep === WizardStep.HOLDER_SELECTION && (
        <HotelHolderData
          paxes={cartPaxes}
          onClose={handleBackToPaxData}
          onContinue={handleHolderDataContinue}
        />
      )}
    </>
  );
};
